// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type Close40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Close40: FC<Close40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m10.472 31.472-1.944-1.944L18.056 20l-9.528-9.528 1.944-1.944L20 18.056l9.528-9.528 1.944 1.944L21.944 20l9.528 9.528-1.944 1.944L20 21.944l-9.528 9.528Z" />
        </svg>
    );
};

export default Close40;
